import templateUrl from './product-label-download.html';

export default {
  templateUrl,
  bindings: {
    product: '<',
    labelChanged: '<'
  },
  controller: class ProductLabelDownloadComponent {
    constructor(ameLightbox, ProductsService, ToastService) {
      'ngInject';

      Object.assign(this, {
        ameLightbox,
        ProductsService,
        ToastService
      });
    }

    $onInit() {
      if (this.product.FileLabelName && this.product.ProductId) {
        if (this.product.FileLabelName.endsWith('.pdf')) {
          this.fileType = 'pdf';

          this.ProductsService.getLabel(this.product.ProductId).then((r) => {
            this.download = r.data;
          });
        } else {
          this.fileType = 'image';
        }
      }
    }

    previewLabelImage(productId) {
      this.ProductsService.getLabelImage(productId)
        .then((r) => {
          this.ameLightbox.show([r.data], {
            buttonClass: 'ng-hide',
            keyboard: false,
            showDots: false
          });
        }).catch(error => this.ToastService.showError(error));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/information/product-label-download/product-label-download.component.js